<template>
	<div class="invite_wrap" v-if="Object.keys(data).length > 0">
		<div class="pop_img" @click="showEwm = false"  v-if="showEwm">
			<div class="yulan" @click.stop>
				<img :src="data.share_image_url" alt="">
			</div>
		</div>
		<div class="basic_wrap">
			<div class="red_top_bg">
				<div class="back_left" @click="$router.back()"></div>
				<div class="big_tit">{{$t('index.invite')}}</div>
				<!-- <div class="back_right" @click="qrcode = true"><img src="../images/user/qrcoder.png"></div> -->
				
				
			</div>
			<div style="height: 44px;"></div>
			<div class="user_top">
				<div class="user_detail">
					<div class="left">
						<div class="user_header">
							<img :src="data.user_icon">
						</div>
						<span>{{data.phone}}</span>
					</div>
					<div class="right">
						<a class="img" @click="showEwm = true">
							<img :src="data.share_image_url" alt="">
						</a>
						<div class="copys">
							<div class="flex">
								<span>{{$t('邀请码')}}:</span>
								<span>{{data.invite_code}}</span>
							</div>
							<a @click="copy(data.invite_code)">
								{{ $t('invest_bank.copy') }}
							</a>
						</div>
					</div>
				</div>
				<div class="copys">
					<span>{{$t('share.shareLink')}}:{{data.share_link}}</span>
					<a @click="copy(data.share_link)">
						{{ $t('invest_bank.copy') }}
					</a>
				</div>
				<div class="user_balance">
					<div class="box">
						<p>{{$t('utils.moneyMark')}}{{data.total_revenue}}</p>
						<p>{{$t('总收益')}}</p>
					</div>
					<div class="box">
						<p>{{$t('utils.moneyMark')}}{{data.yesterday_revenue}}</p>
						<p>{{$t('昨日')}}</p>
					</div>
					<div class="box">
						<p>{{$t('utils.moneyMark')}}{{data.today_revenue}}</p>
						<p>{{$t('今日')}}</p>
					</div>
				</div>
			</div>
			<div class="user_box">
				<div class="num_box">
					<span>{{data.total_user_num}}{{ $t('人') }}</span>
					<span>{{ $t('总数') }}</span>
				</div>
				<div class="bian"></div>
				<div class="num_box">
					<span>{{data.today_user_num}}{{ $t('人') }}</span>
					<span>{{ $t('今日') }}</span>
				</div>
			</div>
			<!-- <div class="introduce">
				    <div class="line left_line"></div>
				    <div class="tit">{{$t('share.introduction')}}</div>
				    <div class="line right_line"></div>
			</div>
			<div class="award_tip">
					<p>{{$t('share.tip1')}}{{data.reward.invest1}}%{{$t('share.tip11')}}</p>
					<p>{{$t('share.tip2')}}{{data.reward.invest2}}%{{$t('share.tip22')}}</p>
					<p>{{$t('share.tip3')}}{{data.reward.invest3}}%{{$t('share.tip33')}}</p>
			</div> -->
			<div class="titles">
				{{ $t('团队列表') }}
			</div>
			<div class="tabs">
				<p :class="active==1?'active':''" @click="change(1)">{{$t('share.level1')}}({{countTop1}})</p>
				<p :class="active==2?'active':''" @click="change(2)">{{$t('share.level2')}}({{countTop2}})</p>
				<p :class="active==3?'active':''" @click="change(3)">{{$t('share.level3')}}({{countTop3}})</p>
			</div>
			<div class="list">
				<div class="item" v-for="i in teamList">
					<div class="time">																		
						{{i.time}}
					</div>
					<div class="box">
						<p>
							<span style="font-weight: bold;">{{ i.phone }}</span>
							<span style="color: #999;">{{ $t('用户') }}</span>
						</p>
						<p style="text-align: right;">
							<span style="font-weight: bold;">{{$t('utils.moneyMark')}} {{data.recharge?data.recharge:0}}</span>
							<span style="color: #999;">{{ $t('累计充值') }}</span>
						</p>
					</div>
				</div>
			</div>
			<van-empty :description="$t('item.noData')" v-if="listLength" />
		</div>
		<div class="mask" v-show="qrcode" @click="qrcode = false">
		    <div class="share_inner">
		        <div class="white_bg">
		            <img class="qrcode" :src="data.share_image_url" alt="" />
					<div @click.stop="downLoad" class="basic_btn">{{$t('share.saveImg')}}</div>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue';
	import Vue from 'vue';
	import {
		Empty
	} from 'vant';
	import Clipboard from "v-clipboard";
	Vue.use(Empty).use(Clipboard);
	export default {
		name: "myTeam",
		data() {
			return {
				data:{},
				countTeam:0,
				countTop1:0,
				countTop2:0,
				countTop3:0,
				active:1,
				teamList:[],
				listLength:true,
				qrcode: false,
				showEwm:false
			};
		},
		components: {
			bsHeader
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/myTeam').then((r) => {
					this.data = r.data;
					this.teamList = r.data.top1;
					if(r.data.top1.length==0){
						this.listLength = true;
					}else{
						this.listLength = false;
					}
					this.countTop1 = r.data.top1.length;
					this.countTop2 = r.data.top2.length;
					this.countTop3 = r.data.top3.length;
					this.countTeam = this.countTop1+this.countTop2+this.countTop3;
				});
			},
			change(num){
				this.active = num;
				this.teamList = this.data[("top"+num)];
				if(this.teamList.length == 0){
					this.listLength = true;
				}else{
					this.listLength = false;
				}
			},
			copy(copyText) {
				let textCopy = document.createElement('textarea')
				const text = copyText
				textCopy.value = text
				document.body.appendChild(textCopy)
				textCopy.select()
				document.execCommand('copy')
				document.body.removeChild(textCopy)
				this.$toast({
					background: "#07c160",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			downLoad(){
			    /*var that = this;
			     jsBridge.saveImageToAlbum(this.data.share_image_url, function(succ) {
			        that.$toast(succ ? "保存成功" : "保存失败：下载失败或没有相册使用权限");
			    }); */
			    this.downloadIamge(this.data.share_image_url,'share.jpg')
			},
			downloadIamge(imgsrc, name) { //下载图片地址和图片名
			    var image = new Image();
			    // 解决跨域 Canvas 污染问题
			    image.setAttribute("crossOrigin", "anonymous");
			    image.onload = function() {
			        var canvas = document.createElement("canvas");
			        canvas.width = image.width;
			        canvas.height = image.height;
			        var context = canvas.getContext("2d");
			        context.drawImage(image, 0, 0, image.width, image.height);
			        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
			
			        var a = document.createElement("a"); // 生成一个a元素
			        var event = new MouseEvent("click"); // 创建一个单击事件
			        a.download = name || "photo"; // 设置图片名称
			        a.href = url; // 将生成的URL设置为a.href属性
			        a.dispatchEvent(event); // 触发a的单击事件
			    };
			    image.src = imgsrc;
			}
		}
	};
</script>

<style lang="less" scoped>
.titles {
	width: 90%;
	font-size: 16px;
	font-weight: bold;
	margin: 0 auto 15px auto;
}
	.red_top_bg {
		height: 44px;
		background-size: 100% 100%;
		position: relative;
		border-radius: 0 0 20% 20%;
		position: fixed;
		z-index: 99;
		.big_tit {
			position: absolute;
		}
		.back_right{
			position: absolute;
			top: 3px;
			right: 3px;
		}
		.introduce {
		    height: 25px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 18px;
		    line-height: 25px;
		    margin-top: 20px;
		
		    .line {
		        width: 36px;
		        height: 10px;
		    }
		
		    .tit {
		        margin: 0 12px;
		        font-weight: bold;
		    }
		
		    .left_line {
		        background: url(../images/user/left_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		
		    .right_line {
		        background: url(../images/user/right_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		}
		.award_tip {
		    font-size: 14px;
		    line-height: 20px;
		    text-align: center;
		    margin: 3px auto 0 auto;
		}
	}
	.user_top{
		width: 100%;
		position: relative;
		background: #3436cc;
		margin: 0 auto;
		padding: 15px 0px;
		.user_detail{
			width: 100%;
			height: fit-content;
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-align: center;
			padding: 0 15px;
			.user_header {
				width: 52px;
				height: 52px;
				overflow: hidden;
				border-radius: 50%;
				img {
					display: block;
					width: 100%;
					height: 100%;
				}
			}
			span{
				margin-left: 5px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
			}
			.left {
				width: 50%;
				display: flex;
				align-items: center;
			}
			.right {
				width: 50%;
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				.img {
					display: block;
					width: 44px;
					height: 44px;
					img{
						display: block;
						width: 100%;
						height: 100%;
					}
				}
				span {
					font-size:14px;
					color: #fff;
				}
				.copys {
					padding: 0px;
					.flex {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
					}
				}
			}
		}
		.copys {
			width: 100%;
			line-height: 18px;
			padding: 0px 15px;
			color: #fff;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			margin-top: 8px;
			a {
					width: fit-content;
					height: fit-content;
					display:block;
					font-size: 14px;
					margin-left: 5px;
					padding: 4px 10px;
					background: #000;
					color: #fff;
					border-radius: 4px;
					white-space: nowrap;
				}
		}
		.user_balance{
			width: 98%;
			height: 75px;
			display: flex;
			align-items: center;
			text-align: center;
			margin: 0 auto;
			margin-top: 5px;
			margin-bottom: 10px;
			.box {
				width: 33%;
				height: fit-content;
				color: #fff;
			}
			p:nth-child(2){
				font-size: 14px;
				margin-top: 10px;
				
			}
			p:nth-child(1){
				
				font-weight: bold;
				font-size: 16px;
				color: #fff;
				white-space: nowrap;
			}
		}
		.user_team{
			display: flex;
			justify-content: space-between;
			text-align: center;
			p{
				width: 50%;
				margin-top: 20px;
				font-size: 14px;
			}
			p:nth-child(1){
				border-right: 1px #999 solid;
			}
			span{
				color: #000;
				font-weight: bold;
			}
			
		}
		.user_share{
			display: flex;
			justify-content: space-between;
			margin: 20px 0 0px 0;
			font-size: 14px;
			p:nth-child(1){
				width: 70%;
				margin-left: 20px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 28px;
			}
			p:nth-child(2){
				text-align: center;
				width: 20%;
				background: #000;
				color: #FFFFFF;
				padding: 6px 0px;
				border-radius: 5px;
				margin-right: 15px;
			}
		}
	}
    .user_box {
		width: 90%;
		height: 70px;
		background: #fff;
		position: relative;
		margin: -20px auto 20px auto;
		box-shadow: 0 4px 10px #ccc;
		display: flex;
		align-items: center;
		border-radius: 8px;
		.bian {
			height: 40px;
			width: 1px;
			background: #000;
		}
		.num_box {
			width: 50%;
			height: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			span:nth-child(1) {
				font-size: 16px;
				color: #000;
				font-weight: bold;
				margin-bottom: 6px;
			}
			span:nth-child(2) {
				font-size: 14px;
				color: #999;
			}
		}
	}
	.tabs{
		display: flex;
		justify-content: space-between;
		text-align: center;
		width: 88%;
		margin-left: 6%;
		margin: 0 auto;
		p{
			width: 30%;
			padding: 5px;
			border-radius: 5px;
			font-size: 13px;
			padding:6px 4px;
		}
		.active{
			background: #000;
			color: #FFFFFF;
		}
	}
	.list{
		margin-top: 15px;
		width: 100%;
		background: #FFFFFF;
		
		.item {
		    height: fit-content;
			box-shadow: 0 4px 10px #ccc; 
		    width: 90%;
		    margin: 0 auto 10px auto;
		    display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border-radius: 8px;
			padding: 10px;
		    border-bottom: 1px solid #E3E4E5;
			.time {
				width: 100%;
				height: 30px;
				display: flex;
				align-items: center;
				font-size: 14px;
				color: #999;
				border-bottom: 1px solid #ccc;
			}
			.box {
				width: 100%;
				display: flex;
				align-items: center;
				padding-top: 5px;
				p {
					width: 50%;
					height: 50px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					span {
						width:100%;
						margin: 4px auto;
						font-size: 14px;
					}
				}
			}
		}
	}
	.mask {
	    position: fixed;
	    top: 0;
	    right: 0;
	    left: 0;
	    bottom: 0;
	    background-color: rgba(0, 0, 0, 0.6);
	    z-index: 30;
	
	    .share_inner {
	        width: 230px;
			height: 280px;
	        position: absolute;
	        top: 60%;
	        left: 0;
	        right: 0;
	        margin: -232px auto 0 auto;
	        background: url(../images/user/share_bg.png) no-repeat center center;
	        background-size: 100% 100%;
			.earn{
				font-size: 32px;
				position: absolute;
				top: 112px;
				color: #fff;
				font-weight: bold;
				width: 100%;
				text-align: center;
			}
			.invite{
				font-size: 20px;
				position: absolute;
				top: 158px;
				color: #fff;
				width: 100%;
				text-align: center;
			}
			
	    }
	
	    .white_bg {
	        width: 160px;
			height: 160px;
	        background-color: #FFFFFF;
	        position: absolute;
	        top: 30px;
			left: 35px;
	        display: flex;
	        justify-content: center;
	        align-items: center;
	
	        img {
	            width: 143px;
	            height: 143px;
	        }
	    }
	
	    .basic_btn {
	        position: absolute;
	        left: 0;
	        right: 0;
	        margin: 0 auto;
	        top: 175px;
			height: 40px;
			line-height: 40px;
			font-size: 14px;
			width: 90%;
	    }
	}
	.pop_img {
		width:100vw;
		height: 100vh;
		position: relative;
		position: fixed;
		left: 50%;
		top:50%;
		transform: translate(-50%,-50%);
		z-index: 99999;
		background: rgba(0,0,0,0.7);
		display: flex;
		align-items: center;
		justify-content: center;

	}
	.yulan {
		width: 300px;
		height: fit-content;
		img {
			display: block;
			width: 100%;
			height: auto;
			object-fit: contain;
		}
	}
</style>
